import { makeRequest } from './request.service'

export const getLeamSummaryData = async (farmId) => {
  try {
    const response = await makeRequest({
      method: 'GET',
      url: `/dashboard/${farmId}/leam-summary`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('secret')}`
      }
    })
    return response.data
  } catch (error) {
    console.error('Error fetching LEAM summary data:', error)
    throw error
  }
}
